import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMapOverview } from './property-map-hooks';
import { MapOverviewScene } from './property-map-scene';
import { NewOrderType } from 'types/order';

const useStyles = makeStyles((theme: any) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    marginBottom: 0,
    boxShadow: theme.shadows[1],
  },
  cardContent: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    letterSpacing: '0.5px',
  },
  propertyDetails: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.spacing(0.5),
  },
  detailLabel: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.text.primary,
    letterSpacing: '0.4px',
    marginBottom: theme.spacing(0.5),
  },
  detailValue: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

type PropertyMapProps = {
  order: NewOrderType;
};

export const PropertyMap: React.FC<PropertyMapProps> = ({ order }) => {
  const classes = useStyles();
  const { t } = useTranslation('closingDisclosure');
  const history = useHistory();
  const properties = order.estates || [];

  const {
    selectProperty,
    selectedProperty,
  } = useMapOverview({ properties });

  const handleMapFeatureClick = () => {
    history.push(`/orders/details/${order._id}/properties`);
  };

  if (!properties || properties.length === 0) {
    return (
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography className={classes.sectionTitle}>
            {t('property-map')}
          </Typography>
          <Typography color="textSecondary">
            {t('no-properties-available')}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Typography className={classes.sectionTitle}>
          {t('property-map')}
        </Typography>

        <Box>
          <MapOverviewScene
            properties={properties}
            selectProperty={selectProperty}
            selectedProperty={selectedProperty}
            onMapFeatureClick={handleMapFeatureClick}
            hideSelector
          />
        </Box>

      </CardContent>
    </Card>
  );
};

export default PropertyMap;
